// extracted by mini-css-extract-plugin
export default {"BottomPanel":"styles_BottomPanel__V+ag7","InfoIcon":"styles_InfoIcon__9FMYN"};